import React, { Component } from 'react'
import { Row, Col, Input, Spin, Button, Table, Select } from 'antd'
import Card from '../../components/Card'
import TeamSeleted from '../../components/TeamSeleted'
import FormModal from '../../components/FormModal2'
import { api, app } from "../../app"
import utils from "../../utils"

const { Option } = Select
const { TextArea } = Input

class TeamDelEditor extends Component {
    constructor (props) {
        super(props)
        this.state = {
            team_loading: true,
            playerList: [],
            teamList: [],
            info_loading: false,
            select_team: {},
            data_load_index: 0,
            volunteer_id: ''
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.teamData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 队伍列表
     **/
    teamData = async () => {
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.TeamAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        this.setData({ team_loading: false, teamList: data })
    }

    /**
     * 恢复队员
     * @param e
     */
    handleRestorePlayer = async ({ reason, current_teamno }) => {
        if (this.state.restore_loading) return false
        await this.setData({ restore_loading: true })
        let { select_team, volunteer_id, load_index } = this.state, params = {
            reason,
            current_teamno,
            user_id: volunteer_id,
            original_teamno: select_team.teamno,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, msg } = await app.post(api.TeamUserRestore, params)
        if (flag === 1) {
            app.alert("操作成功，等待审核", 'success')
            await this.setData({ restore_loading: false, restore_modal: false, volunteer_id: '' })
            await this.teamInfoData(select_team, load_index)
        } else {
            app.alert(msg, "warn")
            await this.setData({ restore_loading: false })
        }
    }

    /**
     * 队伍数据
     * @param select_team
     * @param load_index
     */
    teamInfoData = async (select_team, load_index) => {
        await this.setData({ select_team, load_index, info_loading: true })
        let { flag, data, msg } = await app.post(api.GetTeamAllUserDel, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            team_id: select_team.team_id
        })
        let state = {}
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (this.state.load_index === load_index) {
            state.info_loading = false
            state.playerList = utils.addArrayKey(data)
            await this.setData(state)
        }
    }

    /**
     * 显示添加对话框
     * @param add_modal
     */
    handleOpenRestoreModal = (volunteer_id) => {
        this.setData({ volunteer_id, restore_modal: true })
    }

    /**
     * 隐藏添加对话框
     * @param add_modal
     */
    handleCloseRestoreModal = () => {
        this.setData({ restore_modal: false, volunteer_id: '' })
    }

    render () {
        let formItemLayout = {
                labelCol: { span: 4 },
                wrapperCol: { span: 19, offset: 1 },
            },
            { team_refresh, select_team, restore_modal, restore_loading, playerList, info_loading, team_loading, teamList } = this.state,
            columns = [
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '10%'
                },
                {
                    title: '名称',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%'
                },
                {
                    title: '性别',
                    dataIndex: 'sex',
                    key: 'sex',
                    width: '10%'
                },
                {
                    title: '手机号码',
                    dataIndex: 'mobile',
                    key: 'mobile',
                    width: '15%'
                },
                {
                    title: '身份证号',
                    dataIndex: 'idno',
                    key: 'idno',
                    width: '15%'
                },
                {
                    title: '护照号',
                    dataIndex: 'passport',
                    key: 'passport',
                    width: '10%'
                },
                {
                    title: '入队时间',
                    dataIndex: 'indate',
                    key: 'indate',
                    width: '15%'
                },
                {
                    title: '操作',
                    dataIndex: 'volunteer_id',
                    key: 'volunteer_id',
                    width: '10%',
                    render: (id, {audit}) => {
                        if (audit === '1') {
                            return <Button disabled size='small'>审核中</Button>
                        } else {
                            return <Button type='primary' size='small'
                                           onClick={() => this.handleOpenRestoreModal(id)}>恢复</Button>
                        }
                    }
                }
            ]
        return (
            <div className="team-editor">
                <div className="top-title">已注销队伍</div>
                <Row className="content">
                    <Col span={6} className="team-select">
                        <TeamSeleted refresh={team_refresh} dataApi={api.TeamAllDel} handleData={this.teamInfoData}
                                     refreshLast={() => {
                                         this.setData({ team_refresh: false })
                                     }}/>
                    </Col>
                    <Col span={17} offset={1} className="team-info">
                        <Card width="100%" height="100%"
                              style={{ padding: "20px 20px 0 20px", height: 'calc(100% - 68px)' }}
                              title={select_team.teamname || "队伍名称"}>
                            <Table columns={columns}
                                   locale={app.tbLocale(info_loading)}
                                   dataSource={playerList}
                                   loading={info_loading}
                                   scroll={{ y: 'calc(100% - 55px)' }}
                                   style={{ height: '100%', margin: 0 }}
                                   className="ranks_table"
                                   pagination={false}
                                   size="small"
                            />
                        </Card>
                    </Col>
                </Row>
                <FormModal
                    onSubmit={this.handleRestorePlayer}
                    modal={{
                        visible: restore_modal,
                        title: "队员恢复编辑",
                        onCancel: this.handleCloseRestoreModal,
                        maskClosable: false,
                        destroyOnClose: true,
                        centered: true,
                        okText: '确定',
                        cancelText: '取消',
                        width: 600,
                        confirmLoading: restore_loading,
                    }}
                    children={[
                        {
                            formItemLayout,
                            label: "队伍",
                            name: "current_teamno",
                            options: [{
                                required: true, message: '请选择队伍！',
                            }],
                            component: (
                                <Select showSearch placeholder='请选择队伍' optionFilterProp='children'
                                        notFoundContent={team_loading ? <Spin size="small"/> : null}>
                                    {
                                        teamList.map((team) => {
                                            return (
                                                <Option key={team.team_id} value={team.teamno}>{team.teamname}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            ),
                        },
                        {
                            formItemLayout,
                            label: "恢复原因",
                            name: "reason",
                            options: [{
                                required: true, message: '请输入恢复原因！',
                            }],
                            component: (
                                <TextArea placeholder="请输入恢复原因" autosize={{ minRows: 4, maxRows: 6 }}/>
                            ),
                        }
                    ]}
                />
            </div>
        )
    }
}

export default TeamDelEditor



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamDelEditor.jsx